import React, { useRef, useState } from 'react'
import { useDomAutofill } from '../../hooks/useDomAutofill'
import '../../../styles/buttons.scss'
import s from './styles/SsoLogin.module.scss'
import styleForm from '../../../styles/Form.module.scss'
import { isValidCounselorEmail } from '../../hooks/counselorAuthGate'

export const SsoLogin = ({ loading, authAction, handleSSOLogin }) => {
	const [email, setEmail] = useState('')
	const emailRef = useRef(null)
	const emailValid = isValidCounselorEmail(email)
	const busy = Boolean(loading)
	const ssoBusy = authAction === 'sso'
	const onAutofill = useDomAutofill([
		{ ref: emailRef, value: email, setValue: setEmail },
	])

	const handleSubmit = e => {
		e.preventDefault()
		if (!emailValid || busy) return
		handleSSOLogin(email.trim())
	}

	return (
		<div className={s.wrap}>
			<label className={styleForm.label}>
				Sign in quickly with your Single Sign On
			</label>
			<form onSubmit={handleSubmit}>
				<input
					type="email"
					name="email"
					value={email}
					ref={emailRef}
					onChange={e => setEmail(e.target.value)}
					onAnimationStart={onAutofill}
					autoComplete="username"
					placeholder="Enter your work email"
					className={styleForm.input}
					required
					disabled={busy}
				/>
				<button
					type="submit"
					disabled={busy || !emailValid}
					aria-busy={ssoBusy}
					className={`btn btn-primary ${ssoBusy ? 'loading' : ''}`}
				>
					<span className={`btn__content ${ssoBusy ? 'btn__content--busy' : ''}`}>
						Continue with Single Sign On
					</span>
					{ssoBusy ? <span className="btn__spinner" aria-hidden="true" /> : null}
				</button>
			</form>
		</div>
	)
}
